import Vue from 'vue';
import Router from 'vue-router';
import login from '@/views/login/router/index';
import children from '@/router/routers';

Vue.use(Router);
export default new Router({
  routes: [
    ...login,
    {
      path: '/',
      redirect: '/stage/index'
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index/index'),
      redirect: '/stage/index',
      children
    }
  ]
});
